<template>
  <div>
    <div
        v-if="showLoader"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
          class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-yellow-500"
      ></div>
    </div>
    <div v-else class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <table class="w-full text-left rtl:text-right text-gray-700">
        <thead>
          <tr class="bg-gray-100">
            <th scope="col" class="px-6 py-4">
              <div class="flex items-center">#</div>
            </th>
            <th scope="col" class="px-6 py-4">
              <div class="flex items-center">Bill Number</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Visit Code</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Patient Unique Code</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Patient Name</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Total Amount</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Amount Paid</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Balance</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Bill Date</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Action</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(bill, index) in closedBills"
            :key="index"
            class="border-b"
          >
            <td class="px-6 py-2">{{ index + 1 }}</td>
            <td class="px-6 py-2">{{ bill.bill_number }}</td>
            <td class="px-6 py-2">{{ bill.visit?.VisitCode }}</td>
            <td class="px-6 py-2">{{ bill.patient?.unique_code }}</td>
            <td class="px-6 py-2">{{ bill.patient?.FullName }}</td>
            <td class="px-6 py-2">{{ formatCurrency(bill.total_amount) }}</td>
            <td class="px-6 py-2">{{ formatCurrency(bill.amount_paid) }}</td>
            <td class="px-6 py-2">{{ formatCurrency(bill.balance) }}</td>
            <td class="px-6 py-2">{{ formatDate(bill.created_at) }}</td>
            <td class="px-6 py-2">
              <button
                @click="handleConsultationModal(bill.id)"
                class="bg-custom-yellow text-white px-4 py-1 rounded"
              >
                {{ bill.status.code === "ST-006" ? "Process" : "View" }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <PaginationComponent
        v-model:currentPage="currentPage"
        v-model:itemsPerPage="itemsPerPage"
        :totalPages="totalPages"
        :totalItems="totalItems"
        @update:currentPage="goToPage"
        @update:changePageSize="changePageSize"
    />

    <CashierQueueModal
      :show="showCashierModal"
      :billId="selectedBillId"
      :state="modalState"
      @close="closeCashierModal"
    />
  </div>
</template>
<script>
import CashierQueueModal from "@/views/modals/CashierQueueModal.vue";
import PaginationComponent from "@/components/shared/pagination.vue";
import apiClient from "@/services/api";

export default {
  name: "CashierQueueTab",
  components: {
    CashierQueueModal,
    PaginationComponent,
  },
  mounted() {
    this.fetchClosedBills();
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showCashierModal: false,
      showProcedureModal: false,
      selectedBillId: null,
      modalState: "create",
      patients: [],
      showLoader: false,
      currentPage: 1,
      itemsPerPage: 10,
      pageSizes: [25, 50, 100],
      bills: [],
      totalItems: 0, // New: Total items from backend
      totalPages: 0, // New: Total pages from backend
      closedBills: []
    };
  },
  computed: {
    getVisitType() {
      return (visitType) => {
        switch (visitType) {
          case "Consultation":
            return "bg-green-200";
          case "Triage Procedure":
            return "bg-yellow-200";
          default:
            return "";
        }
      };
    },
  },
  methods: {
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchClosedBills();
    },
    changePageSize(pageSize) {
      this.itemsPerPage = pageSize;
      this.fetchClosedBills();
    },
    async fetchClosedBills() {
      try {
        this.showLoader = true;
        const response = await apiClient.fetchClosedBills({
          page: this.currentPage,
          per_page: this.itemsPerPage,
        });
        if (response.success) {
          this.showLoader = false;
          this.closedBills = response.data;
          this.totalItems = response.meta.total_items; // Assuming meta data from backend
          this.totalPages = response.meta.total_pages; // Assuming meta data from backend
          this.itemsPerPage = response.meta.per_page;
          // this.$toast.success("Facility services fetched successfully");
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to fetch bills");
        console.log(error);
      }
    },
    handleConsultationModal(billId) {
      const selectedBill = this.closedBills.find((bill) => bill.id === billId);

      if (selectedBill) {
        this.selectedBillId = billId;
        this.showCashierModal = true;
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "KES",
      }).format(value);
    },
    closeCashierModal() {
      this.showCashierModal = false;
      this.showProcedureModal = false;
    },
    formatDate(dateString) {
      const options = {
        // "Monday"
        year: "numeric", // "2025"
        month: "long", // "January"
        day: "numeric", // "22"
        hour: "numeric", // "1 PM"
        minute: "numeric", // "43"
        hour12: true, // 12-hour time format
      };
      const date = new Date(dateString);
      return date.toLocaleString("en-US", options);
    },
  },
};
</script>

<style lang="css" scoped></style>
